<template>
  <div style="margin-top: 45px; background-color: #F5F6F9;">
    <div class="container-banner">
      <img :src="classDetail.image_url" class="img-banner" />
      <div class="left-banner">
        <div class="label-list">
          <div class="btn-white-oval font-poppins">{{ classDetail.level }}</div>
          <div class="btn-white-oval font-poppins">{{ classDetail.method | toMethod }}</div>
        </div>
        <div style="margin-top: 24px; padding: 0 10px;">
          <span class="text-banner">{{ classDetail.name }}</span>
        </div>
        <div class="button-banner-container">
          <Button :name="$t('prakerjaDetail.headSection.button')" @click="goToCheckoutPage" :bold="true"
            width="90%" style="background-color: #FFDE59; color: #36373F; font-size: 16px; padding: 15px 0;" />
        </div>
        <div class="collaboration-banner-container">
          <p style="margin: 0;">{{ $t('corpAcelerationDetail.collaboration.title') }}</p>
          <img src="/img/home/label-prakerja.png" alt="prakerja">
        </div>
      </div>
    </div>
    <div class="section-container">
      <span class="font-poppins">{{ $t('prakerjaDetail.infoKelasSection.title') }}</span>
      <h5 class="title">{{ $t('prakerjaDetail.infoKelasSection.descriptionProgram') }}</h5>
      <p class="desc">{{ classDetail.description }}</p>
    </div>
    <div class="box-steps" style="padding: 64px 0 !important;">
      <div class="box-steps-ctn py-4" style="display: flex;" @click="toggleDetailClass">
        <h5 class="title">{{ $t('prakerjaDetail.detailKelasSection.title') }}</h5>
        <ArrowIc :down="!isDetailClass" />
      </div>
      <div class="box-steps-ctn" v-if="isDetailClass">
        <p v-html="classDetail.learning_objective"></p>
        <h3 class="my-3">{{ $t('prakerjaDetail.detailKelasSection.targetAudience') }}</h3>
        <ul>
          <li v-for="(item, idx) in classDetail.target_audience" :key="idx" class="font-poppins">{{ item.level }}</li>
        </ul>
        <h3 class="my-3">{{ $t('prakerjaDetail.detailKelasSection.learningMethod') }}</h3>
        <p v-html="classDetail.learning_method"></p>
        <h3 class="my-3">{{ $t('prakerjaDetail.detailKelasSection.evaluationTools') }}</h3>
        <ul>
          <li v-for="(item, idx) in evaluasi" :key="idx" class="font-poppins">{{ item }}</li>
        </ul>
        <h3 class="my-3">{{ $t('prakerjaDetail.detailKelasSection.termsAndConditions') }}</h3>
        <ul>
          <li v-for="(item, idx) in classDetail.requirements" :key="idx" class="font-poppins">{{ item.name }}</li>
        </ul>
        <div class="btn-hide" @click="toggleDetailClass">
          <span>{{ $t('prakerjaDetail.detailKelasSection.hideButton') }}</span>
          <arrow-ic />
        </div>
      </div>
    </div>
    <div class="section-container" style="background-color: #F1F6FF; padding-bottom: 80px">
      <span class="font-poppins">{{ $t('prakerjaDetail.materiPembelajaranSection.title') }}</span>
      <h5 class="title">{{ $t('prakerjaDetail.materiPembelajaranSection.subtitle') }}</h5>
      <div class="syllabus-summary">
        <p>{{ classDetail.syllabuses.length }} Topik Materi • {{ 17 }} Pelajaran • {{ 9 }} Jam Total Durasi
        </p>
      </div>
      <div v-for="(item, idx) in classDetail.syllabuses" :key="idx" class="box-steps" style="margin-top: 28px;">
        <div class="box-steps-ctn pb-3" style="display: flex;" @click="toggleSyllabus(idx)">
          <div>
            <span class="font-poppins">{{ $t('prakerjaDetail.materiPembelajaranSection.sessionPrefix') }} {{ idx + 1
              }}</span>
            <h4 v-for="(item2, idx2) in item.name" :key="idx2">{{ item2 }}</h4>
          </div>
          <ArrowIc :down="!item.show" />
        </div>
        <div class="box-steps-ctn border-top pa-5" v-if="item.show">
          <div class="list-art" v-if="idx === 0">
            <img src="/img/icons/file.png" alt="File">
            <div class="info-ars">
              <p>{{ $t('prakerjaDetail.materiPembelajaranSection.preTest') }}</p>
              <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.initialExam') }}</p>
            </div>
          </div>
          <div class="list-art">
            <img src="/img/icons/easel.png" alt="File">
            <div class="info-ars">
              <p>{{ $t('prakerjaDetail.materiPembelajaranSection.liveSession') }} : {{ item.name[0] }}</p>
              <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.liveShareDeck') }}</p>
            </div>
          </div>
          <div class="list-art">
            <img src="/img/icons/file.png" alt="File">
            <div class="info-ars">
              <p>{{ $t('prakerjaDetail.materiPembelajaranSection.formativeTest') }}</p>
              <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.quiz') }} {{ idx + 1 }}</p>
            </div>
          </div>
          <div class="list-art" v-if="idx < 4">
            <img src="/img/icons/file.png" alt="File">
            <div class="info-ars">
              <p>{{ $t('prakerjaDetail.materiPembelajaranSection.individualAssignment') }} {{ idx + 1 }}</p>
              <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.individualAssignment') }}</p>
            </div>
          </div>
          <div class="list-art" v-if="idx >= classDetail.syllabuses.length - 1">
            <img src="/img/icons/file.png" alt="File">
            <div class="info-ars">
              <p>{{ $t('prakerjaDetail.materiPembelajaranSection.postTest') }}</p>
              <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.finalExam') }}</p>
            </div>
          </div>
          <div class="list-art" v-if="idx >= classDetail.syllabuses.length - 1">
            <img src="/img/icons/file.png" alt="File">
            <div class="info-ars">
              <p>{{ $t('prakerjaDetail.materiPembelajaranSection.unjukKeterampilan') }}</p>
              <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.individualAssignment') }}</p>
            </div>
          </div>
        </div>
        <div class="btn-syllabus-hide" @click="toggleSyllabus(idx)">
          <ArrowIc :down="!item.show" />
        </div>
      </div>
    </div>

    <div class="section-container" style="margin-top: 30px;">
      <h5 class="title">{{ $t('prakerjaDetail.benefitSection.title') }}</h5>
      <BenefitPrakerja style="margin-top: 32px" />
    </div>

    <div class="section-container" style="margin-top: -40px;">
      <span>{{ $t('prakerjaDetail.instrukturSection.title') }}</span>
      <h5 class="title">{{ $t('prakerjaDetail.instrukturSection.subtitle') }}</h5>
      <div class="instructor">
        <img :src="$utils.loadImage(instructor.image_url)" alt="">
        <div class="instructor-detail">
          <h5 class="title">{{ instructor.name }}</h5>
          <span class="sub-title-narasumber">{{ instructor.position }} {{ instructor.company ? `/${instructor.company}`
            : "" }}</span>
        </div>
      </div>
      <p class="instructor-description">{{ instructor.description }}</p>
    </div>

    <div class="section-container" style="margin-top: -40px;">
      <span>{{ $t('prakerjaDetail.scheduleSection.title') }}</span>
      <h5>{{ $t('prakerjaDetail.scheduleSection.subtitle') }}</h5>
      <div class="schedule">
        <h3 class="schedule-title">{{ classDetail.name }}</h3>
        <div class="schedule-list">
          <EmptyData v-if="!classDetail.schedules || !classDetail.schedules.length"
            message="Belum ada Jadwal saat ini" />
          <div class="schedule-item" v-for="(item, idx) in classDetail.schedules" :key="idx">
            <Date fill="#7B7E8C" :width="24" :height="24" />
            <div class="schedule-detail">
              <p class="schedule-date">{{ $utils.formatDate(item.start_date) }} - {{ $utils.formatDate(item.end_date) }}
              </p>
              <p class="schedule-hour">({{ item.hours }} WIB)</p>
              <p class="schedule-quota">available</p>
            </div>
          </div>
          <div class="class-schedule-detail">
            <div class="class-schedule-detail-level">
              <p class="class-schedule-detail-key">{{ $t('prakerjaDetail.scheduleSection.labels.trainingLevel') }}</p>
              <p class="class-schedule-detail-value">{{ classDetail.level }}</p>
            </div>
            <div class="class-schedule-detail-quota">
              <p class="class-schedule-detail-key">{{ $t('prakerjaDetail.scheduleSection.labels.participantQuota') }}
              </p>
              <p class="class-schedule-detail-value">{{ 50 }}</p>
            </div>
            <div class="class-schedule-detail-session">
              <p class="class-schedule-detail-key">{{ $t('prakerjaDetail.scheduleSection.labels.trainingSession') }}</p>
              <p class="class-schedule-detail-value">{{ classDetail.session_total }}</p>
            </div>
            <div class="class-schedule-detail-method">
              <p class="class-schedule-detail-key">{{ $t('prakerjaDetail.scheduleSection.labels.trainingMethod') }}</p>
              <p class="class-schedule-detail-value">{{ classDetail.method | toMethod }}</p>
            </div>
          </div>
          <div class="confirm-purchase-class">
            <h3>{{ $t('prakerjaDetail.scheduleSection.confirmationPurchase.title') }}</h3>
            <p>{{ $t('prakerjaDetail.scheduleSection.confirmationPurchase.description') }}</p>
            <Button :name="$t('prakerjaDetail.scheduleSection.confirmationPurchase.ctaButton')"
              @click="goToCheckoutPage" :bold="true" width="100%"
              style="background-color: #162CA2; color: white; font-size: 16px; padding: 15px 0; margin-top: 32px;" />
          </div>
          <p class="question-to-purchase">{{ $t('prakerjaDetail.scheduleSection.questionToPurchase') }}</p>
          <div class="class-price-box">
            <h5 class="class-price-box-header">{{ $t('prakerjaDetail.scheduleSection.regularPriceSection.header') }}
            </h5>
            <div class="class-price-box-body">
              <h5>{{ formatIDR(classDetail.price) }}</h5>
              <p>{{ $t('prakerjaDetail.scheduleSection.regularPriceSection.note') }}</p>
            </div>
          </div>
          <div class="prakerja-partner">
            <p>{{ $t('prakerjaDetail.a1') }}</p>
            <div class="prakerja-partner-img-list">
              <div v-for="(partner, index) in $t('prakerjaDetail.scheduleSection.prakerjaPartners')" :key="index"
                class="ctn-img-prakerja" @click="goToPartner(partner.url)">
                <img :src="partner.image" class="img-prakerja-partner" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowIc from "@/assets/icons/Arrow.vue";
import BenefitPrakerja from "@/components/prakerja/BenefitPrakerja.vue";
import Button from "../../others/Button.vue";
import moment from "moment";
import EmptyData from "../../others/EmptyData.vue";
import Date from "../../../assets/icons/DateIc2.vue";

export default {
  components: {
    BenefitPrakerja,
    Button,
    ArrowIc,
    Date,
    EmptyData,
  },
  data() {
    return {
      publicClass: [
        { message: "Lebih dari satu peserta (max 10)" },
        { message: "Jadwal kelas telah ditentukan" },
        { message: "Diajarkan langsung oleh instruktur" },
        { message: "Gratis Survival Kit" },
        { message: "Sertifikat" },
      ],
      privateClass: [
        { message: "Hanya satu peserta" },
        { message: "Dapat menentukan jadwal kelas" },
        { message: "Diajarkan langsung oleh instruktur" },
        { message: "Gratis Survival Kit" },
        { message: "Sertifikat" },
      ],
      evaluasi: [
        "Pre-Test",
        "Kuis",
        "Tugas Praktik Mandiri",
        "Post-Test",
        "Uji Keterampilan"
      ],
      faq: [
        {
          description:
            "Memiliki laptop / PC yang dilengkapi webcam dan tambahan headset + mic untuk menunjang pembelajaran.",
          title: "Apa yang harus dipersiapkan untuk mengikuti pelatihan?",
        },
        {
          description:
            "Memiliki laptop / PC yang dilengkapi webcam dan tambahan headset + mic untuk menunjang pembelajaran.",
          title: "Apa yang harus dipersiapkan untuk mengikuti pelatihan?",
        },
        {
          description:
            "Memiliki laptop / PC yang dilengkapi webcam dan tambahan headset + mic untuk menunjang pembelajaran.",
          title: "Apa yang harus dipersiapkan untuk mengikuti pelatihan?",
        },
      ],
      menuPublicClass: [
        { name: "Info Kelas", id: 1 },
        { name: "Materi Silabus", id: 2 },
        { name: "Benefit", id: 3 },
        { name: "Path Career", id: 4 },
        { name: "Biaya Kelas", id: 5 },
        { name: "Alur Pendaftaran", id: 6 },
        { name: "FAQ", id: 7 },
      ],
      isDetailClass: true,
      classDetail: {
        requirements: [],
        syllabuses: []
      },
      instructor: {},
      questions: [
        {
          title: "Bagaimana mekanisme pelatihan yang dilakukan secara luring atau offline?",
          description: "Pelatihan metode luring/offline dilakukan pada lokasi yang telah disepakati bersama, dengan didampingi oleh staff HiColleagues peserta dan instruktur dapat fokus menjalankan pelatihan dengan maksimal.",
          active: true
        },
        {
          title: "Bagaimana mekanisme pelatihan yang dilakukan secara luring atau offline?",
          description: "Pelatihan metode luring/offline dilakukan pada lokasi yang telah disepakati bersama, dengan didampingi oleh staff HiColleagues peserta dan instruktur dapat fokus menjalankan pelatihan dengan maksimal.",
          active: true
        },
        {
          title: "Apa saja yang dipersiapkan untuk menjalin kemitraan Corporate Service dengan HiColleagues?",
          description: "Pelatihan metode luring/offline dilakukan pada lokasi yang telah disepakati bersama, dengan didampingi oleh staff HiColleagues peserta dan instruktur dapat fokus menjalankan pelatihan dengan maksimal.",
          active: true
        },
      ]
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getDetailClass();
    },
  },
  methods: {
    goToCheckoutPage() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Checkout - ${this.classDetail.name} - Prakerja Detail Page`,
        value: 1,
      });
      var classType = "";
      if (this.$route.query.tipe_kelas == "prakerja") {
        classType = "PRAKERJA_CLASS";
      } else if (this.$route.query.tipe_kelas == "public-bootcamp") {
        classType = "BOOTCAMP_CLASS";
      }

      const req = JSON.stringify({
        class_id: this.classDetail.class_id,
        class_name: this.classDetail.name,
        price: this.classDetail.price,
        level: this.classDetail.level,
        session: this.classDetail.session_total,
        hour: this.classDetail.hours,
        image_url: this.classDetail.small_image_url,
        class_type: classType,
        days: this.classDetail.days,
        methode: this.classDetail.method,
        category_id: this.classDetail.category_id,
      });

      localStorage.clear();
      localStorage.setItem("checkout", req);
      window.location.href = "/checkout";
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Contact Customer Service - Prakerja Detail Page',
        value: 1,
      });
      window.open('https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya');
    },
    goToCustomerService() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Contact Customer Service - Prakerja Detail Page',
        value: 1,
      });
      window.location.href =
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi Kak HiColleagues, saya mau bertanya";
    },
    toggleAccordion(index) {
      this.questions[index].active = !this.questions[index].active;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle FAQ - ${this.questions[index].title} - Prakerja Detail Page`,
        value: 1,
      });
    },
    async getDetailClass() {
      try {
        const response = await this.$http.get(`/v1/class-detail/${this.$route.params.slugname}`);
        this.classDetail = {
          ...response.data.data.class_detail,
          syllabuses: response.data.data.class_detail.syllabuses.map(item => ({
            ...item,
            name: item.description.split("<li>").map(item2 => item2.replace("</ul>", "").replace("</li>", "")),
            show: true,
          }))
        };
        this.classDetail.syllabuses = this.classDetail.syllabuses.map(item => {
          item.name.splice(0, 1);
          return {
            ...item,
            name: item.name
          }
        });
        this.instructor = response.data.data.instructor;
      } catch {
        this.$router.push('/prakerja');
      }
    },
    formatIDR(amount) {
      if (!amount) return amount;
      return "IDR " + amount.toLocaleString("id-ID");
    },
    formatDate(date) {
      return moment(date).format("dddd, DD/MM/YYYY");
    },
    toggleDetailClass() {
      this.isDetailClass = !this.isDetailClass;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle Class Details - ${this.isDetailClass ? 'Expand' : 'Collapse'} - Prakerja Detail Page`,
        value: 1,
      });
    },
    toggleSyllabus(idx) {
      this.classDetail.syllabuses[idx].show = !this.classDetail.syllabuses[idx].show;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle Syllabus - Session ${idx + 1} - Prakerja Detail Page`,
        value: 1,
      });
    },
    goToPartner(url) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Visit Partner - ${url} - Prakerja Detail Page`,
        value: 1,
      });
      this.$utils.redirect(url);
    },
  },
  mounted() {
    this.getDetailClass();
    this.$gtag.pageview(this.$route);
  },
  filters: {
    toMethod(value) {
      if (!value) return '';
      return value === "Online" ? "Daring (via Zoom)" : value;
    }
  }
};
</script>

<style src="./detailClass.css" scoped></style>